import KPITable from "@/components/KPITable.tsx"
import { Label } from "@/components/ui/label.tsx"
import { ScrollArea, ScrollBar } from "@/components/ui/scroll-area.tsx"

import IncentiveBar from "./IncentiveBar.tsx"
import KPISummaryTable from "./KPISummaryTable.tsx"

import type { IncentiveRowConfig } from "../types/incentiveRowTypes.ts"

export default function IncentiveRow({ config }: { config: IncentiveRowConfig }) {
  return (
    <div className="w-full flex">
      <ScrollArea type="always" className="w-1 flex-1 ">
        <ScrollBar orientation="horizontal" className="w-full" />
        <div className="grid grid-cols-10 gap-2 min-w-[1500px] p-1">
          <IncentiveBar
            asOf={config.asOf || new Date()}
            kpi={config.targetKpi}
            label={config.gaugeLabel}
            fetcher={config.targetFetcher}
          />
          <div className="rounded-md shadow-sm border flex flex-col justify-end col-span-2">
            <h2 className="bg-card-header text-lg font-semibold px-4 pt-3 border-b h-[52.5px] shrink-0 rounded-t-md">
              {config.opExLabel}
            </h2>
            <div className="w-full h-full grow flex justify-center">
              <svg className="max-w-[300px]" height="98%" viewBox="0 0 200 150">
                <g>
                  <rect width={100} height={120} fill="var(--chart-1)" x={50} y={20} />
                </g>
                <g>
                  <text
                    textAnchor="middle"
                    x={100}
                    y={75}
                    className="font-semibold select-none"
                    fill="white"
                    dominantBaseline="central"
                  >
                    ${config.opExTarget.toLocaleString()}
                  </text>
                  <text
                    textAnchor="middle"
                    dominantBaseline="central"
                    x={100}
                    y={90}
                    className="select-none text-[8px]"
                    fill="white"
                  >
                    (target)
                  </text>
                </g>
              </svg>
            </div>
            <div className="flex flex-col justify-center items-center h-full mt-0 mb-4 grow-0">
              <Label className="text-center text-muted-foreground text-[12pt] font-semibold">
                OpEx - Site Costs
              </Label>
            </div>
          </div>
          <div className="col-span-5 rounded-md shadow-sm border">
            <KPITable
              request={config.kpis}
              showAverage={config.hideAverage ? false : true}
              paddingArray={config.paddingArray}
              refetchInterval={10 * 60 * 1000}
            />
          </div>
          <div className="col-span-1">
            <KPISummaryTable asOf={config.asOf || new Date()} kpis={config.kpis.kpis} />
          </div>
        </div>
      </ScrollArea>
    </div>
  )
}
